import Input from 'react-phone-number-input/input';
import { FormField } from 'grommet';
import styled from 'styled-components';
import theme from '@theme/sbot.theme';
import { TypographySettings } from '@theme/globals/typography';

const colors = theme.global.colors;
const control = theme.global.control;
const input = theme.global.input;

export const StyledFormField = styled(FormField)`
  border-color: red;
  &.is-borderless {
    & > div {
      border: none;
    }
  }
  &.is-borderless.has-error {
    & > span {
      display: none;
    }
  }
`;

export const StyledInputPhoneNumber = styled(Input)`
  appearance: none;
  border-radius: ${control.border.radius};
  border: 0;
  box-sizing: border-box;
  color: ${colors['text' as keyof typeof colors]};
  font-family: ${TypographySettings.subhead.family};
  font-size: ${TypographySettings.subhead.size};
  font-weight: ${TypographySettings.subhead.weight};
  line-height: ${TypographySettings.subhead.height};
  padding: ${input.padding.vertical} ${input.padding.horizontal};
  width: 100%;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${colors['gray-200']};
  }
  &.has-error {
    color: ${colors['dk-red']};
  }
`;

export default StyledInputPhoneNumber;
